// Shared SSR-safe prefers-reduced-motion check — call sites just need the boolean, not a live
// subscription (see useMediaQuery for the reactive hook version used elsewhere in the app).
export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
